import type { IPopupContext, IPopupViewModel } from '../../services/i-popup-service';
import type { Language } from '../../dto/language';

export interface MnemonicPopupItem {
	wordId: string;
	word: string;
	transliteration?: string;
	translation: string;
	normalizedWord?: string;
	normalizedTranslation?: string;
	mnemonicText: string;
	imageUrl: string;
}

export class MnemonicPopupViewModel implements IPopupViewModel<null> {
	public readonly popupId = 'mnemonic' as const;

	private context: IPopupContext<null> | null = null;

	constructor(
		public readonly partIndex: number,
		public readonly totalParts: number,
		public readonly translatedWordLanguage: Language,
		public readonly sourceWordLanguage: Language,
		public readonly nativeLanguage: Language,
		public readonly items: readonly MnemonicPopupItem[]
	) {
	}

	public init(context: IPopupContext<null>): void {
		this.context = context;
	}

	public handleOk(): void {
		this.context?.closePopup(null);
	}

	public handleClose(): void {
		this.handleOk();
	}
}
